import remote from './remote'

const URL = {
    GET: '/cms/system/resources'
}

export default {
    getSystemResources () {
        return remote.request({
            url: remote.getUrl(URL.GET)
        })
    }
}
